export default __webpack_public_path__ + "static/media/GeoFDA_Icon.ff5301fa.ico";